// DEPENDECIES
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useFormik } from 'formik';
// COMPONENTS
import MUIDataTable from 'mui-datatables';
import { Button, Modal, Form } from 'react-bootstrap';
import SVG from 'react-inlinesvg';
// CUSTOM COMPONENTS
import * as alert from '../../../redux/alertSnackBarRedux';
import * as confirmModal from '../../../redux/confirmModalRedux';
// SERVICES AND HELPERS
import * as annualQuotaService from '../../../services/management/annualQuotaService';
import { toAbsoluteUrl } from '../../../_metronic/_helpers';
import AnnualQuotaValidator from '../../../helpers/validators/AnnualQuotaValidator';
import { getInputClasses } from '../../../helpers/helper';

var initialAnnualQuota = {
  id: 0,
  year: null,
  amount: null,
};

const AnnualQuotaListingPage = (props) => {
  const { showAlert, showConfirmModal, hideConfirmModal } = props;
  const [data, setData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedAnnualQuota, setSelectedAnnualQuota] = useState(initialAnnualQuota);

  useEffect(() => {
    loadTableData();
  }, []);

  const loadTableData = () => {
    annualQuotaService
      .getAnnualQuotas()
      .then((res) => {
        setData(res);
      })
      .catch((ex) => {
        showAlert({ message: ex.message, variant: 'error' });
      });
  };

  const editAnnualQuota = (id) => {
    annualQuotaService.getAnnualQuotaById(id).then((res) => {
      setSelectedAnnualQuota(res);
      setIsModalOpen(true);
    });
  };

  const deleteAnnualQuota = (id) => {
    annualQuotaService.deleteAnnualQuota(id).then((res) => {
      showAlert({ message: res.message, variant: 'success' });
      loadTableData();
      hideConfirmModal();
    });
  };

  const columns = [
    {
      name: 'id',
      label: 'Actions',
      options: {
        filter: false,
        sort: false,
        width: 15,
        download: false,
        setCellProps: () => ({ style: { width: '20%' }, 'data-aes-field': 'actions' }),
        setCellHeaderProps: () => ({ 'data-aes-field': 'actions' }),
        customBodyRenderLite: (dataIndex) => {
          return (
            <div className='aes-admin-listing-actions'>
              <button
                className='btn btn-sm btn-info font-weight-bold py-2 px-3 px-xxl-5'
                onClick={() => editAnnualQuota(data[dataIndex].id)}
              >
                Edit
              </button>
              <button
                onClick={() =>
                  showConfirmModal({
                    title: 'Delete AnnualQuota',
                    text: 'Are you sure you want to delete this annualQuota?',
                    rightBtnText: 'Confirm',
                    btnAction: () => deleteAnnualQuota(data[dataIndex].id),
                  })
                }
                className='btn btn-sm btn-danger font-weight-bold py-2 px-3 px-xxl-5 my-1'
              >
                Delete
              </button>
            </div>
          );
        },
      },
    },
    {
      name: 'year',
      label: 'Year',
      options: {
        filter: true,
        sort: true,
        setCellProps: () => ({ 'data-aes-field': 'primary', 'data-aes-label': 'Year' }),
        setCellHeaderProps: () => ({ 'data-aes-field': 'primary' }),
      },
    },
    {
      name: 'amount',
      label: 'Amount',
      options: {
        filter: true,
        sort: true,
        setCellProps: () => ({ 'data-aes-field': 'detail', 'data-aes-label': 'Amount' }),
        setCellHeaderProps: () => ({ 'data-aes-field': 'detail' }),
        customBodyRenderLite: (dataIndex) => <p>${data[dataIndex].amount}</p>,
      },
    },
  ];

  const handleModalClose = () => {
    setIsModalOpen(false);
    setSelectedAnnualQuota(initialAnnualQuota);
    formik.resetForm();
  };

  const saveAnnualQuota = (values, setStatus, setSubmitting) => {
    annualQuotaService
      .saveAnnualQuota(values)
      .then((res) => {
        showAlert({ message: res.message, variant: 'success' });
        loadTableData();
        handleModalClose();
      })
      .catch((ex) => {
        showAlert({ message: ex.message, variant: 'error' });
      });
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: selectedAnnualQuota,
    validationSchema: AnnualQuotaValidator,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      saveAnnualQuota(values, setStatus, setSubmitting);
    },
  });

  return (
    <div className='row aes-admin-listing-page aes-admin-listing-page--annual-quotas'>
      <Modal centered size='lg' show={isModalOpen} onHide={handleModalClose}>
        <form className='card card-custom' onSubmit={formik.handleSubmit}>
          <Modal.Header closeButton>
            <Modal.Title>Annual Quota</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className='form'>
              <div className='form-group row'>
                <label className='col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600'>Year</label>
                <div className='col-lg-9 col-xl-9'>
                  <div className='input-group input-group-lg input-group-solid'>
                    <input
                      placeholder='Start typing...'
                      className={`form-control form-control-lg form-control-solid ${getInputClasses(formik, 'year')}`}
                      name='year'
                      type='number'
                      {...formik.getFieldProps('year')}
                    />
                  </div>
                  {formik.touched.year && formik.errors.year ? (
                    <div className='invalid-feedback display-block'>{formik.errors.year}</div>
                  ) : null}
                </div>
              </div>
              <div className='form-group row'>
                <label className='col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600'>Amount</label>
                <div className='col-lg-9 col-xl-9'>
                  <div className='input-group input-group-lg input-group-solid'>
                    <input
                      placeholder='Start typing...'
                      className={`form-control form-control-lg form-control-solid ${getInputClasses(formik, 'amount')}`}
                      name='amount'
                      type='number'
                      {...formik.getFieldProps('amount')}
                    />
                  </div>
                  {formik.touched.amount && formik.errors.amount ? (
                    <div className='invalid-feedback display-block'>{formik.errors.amount}</div>
                  ) : null}
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant='secondary' onClick={handleModalClose}>
              Close
            </Button>
            <button type='submit' className='btn btn-success mr-2' disabled={formik.isSubmitting || (formik.touched && !formik.isValid)}>
              Save
              {formik.isSubmitting}
            </button>
          </Modal.Footer>
        </form>
      </Modal>
      <div className='col-lg-12 col-xxl-12'>
        <div className={`card card-custom card-stretch gutter-b}`}>
          <div className='card-header border-0 py-5'>
            <h3 className='card-title align-items-start flex-column'>
              <span className='card-label font-weight-bolder text-dark'>Annual Quotas</span>
              <span className='text-muted mt-3 font-weight-bold fz-xs'>View and Manage Annual Quotas</span>
            </h3>
            <div className='card-toolbar'>
              <button onClick={() => setIsModalOpen(true)} className='btn btn-success font-weight-bolder font-size-sm mr-3'>
                <span className='svg-icon svg-icon-lg svg-icon-white'>
                  <SVG src={toAbsoluteUrl('/media/svg/icons/Code/Plus.svg')} />
                </span>{' '}
                Add AnnualQuota
              </button>
            </div>
          </div>
          <div className='container-fluid aes-admin-listing p-0'>
            <MUIDataTable
              className='aes-admin-listing-surface'
              data={data}
              columns={columns}
              options={{
                responsive: 'standard',
                rowsPerPage: 25,
                rowsPerPageOptions: [10, 15, 20, 25, 30, 35, 40, 45, 50, 100],
                selectableRows: 'none',
                setTableProps: () => ({
                  className: 'aes-admin-listing-table',
                }),
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default connect(null, { ...alert.actions, ...confirmModal.actions })(AnnualQuotaListingPage);
